var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIconLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_125",
    "data-name": "Subtraction 125",
    d: "M-14916-13411a12.01,12.01,0,0,1-12-12,12.014,12.014,0,0,1,12-12,12.016,12.016,0,0,1,12,12A12.012,12.012,0,0,1-14916-13411Zm.136-8.665a1.336,1.336,0,0,0-1.336,1.335,1.335,1.335,0,0,0,1.336,1.329h.013a1.334,1.334,0,0,0,1.335-1.329,1.336,1.336,0,0,0-1.335-1.335Zm0-9.332a1.337,1.337,0,0,0-1.336,1.333v5.332a1.337,1.337,0,0,0,1.336,1.335,1.337,1.337,0,0,0,1.335-1.335v-5.332A1.336,1.336,0,0,0-14915.866-13429Z",
    transform: "translate(14928 13435.002)",
    fill: "#9fa2a3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIconLight);
export default __webpack_public_path__ + "static/media/InfoIconLight.dbf95f1000331c446f00a57b70929688.svg";
export { ForwardRef as ReactComponent };